/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_collection_language_title23 = /** @type {(inputs: {}) => string} */ () => {
	return `Language`
};

const fr_collection_language_title23 = /** @type {(inputs: {}) => string} */ () => {
	return `Langue`
};

const de_collection_language_title23 = /** @type {(inputs: {}) => string} */ () => {
	return `Sprache`
};

const es_collection_language_title23 = /** @type {(inputs: {}) => string} */ () => {
	return `Idioma`
};

const it_collection_language_title23 = /** @type {(inputs: {}) => string} */ () => {
	return `Lingua`
};

const ar_collection_language_title23 = /** @type {(inputs: {}) => string} */ () => {
	return `اللغات`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const collection_language_title23 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.collection_language_title23(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("collection_language_title23", locale)
	if (locale === "en") return en_collection_language_title23(inputs)
	if (locale === "fr") return fr_collection_language_title23(inputs)
	if (locale === "de") return de_collection_language_title23(inputs)
	if (locale === "es") return es_collection_language_title23(inputs)
	if (locale === "it") return it_collection_language_title23(inputs)
	return ar_collection_language_title23(inputs)
};
export { collection_language_title23 as "COLLECTION_LANGUAGE_TITLE" }